module.exports = __webpack_public_path__ + "static/media/Home_insurance.82e83a3c.svg";